<template>
  <div class="userinfoBox">
    <div class="isLoadingBox" v-loading="isLoading">

      <!-- 用户信息不完善时样式 -->
      <div class="userinfo bg_fff" :class="[isLoading?'opacity':'']" v-if="!userInfoState">
        <div>
          <!-- 顶部模块 -->
          <div class="heade">
            <div class="title clearfix">
              <span class="f_18 color_40 fl font_w_b">{{userInfoState?'个人信息':'完善个人信息'}}</span>
              <!-- <p class="jumpOver f_16 color_blue fr cursor_p" v-if="!isjumpOver" @click="$router.replace({name:'talentSearchIndex'})">跳过</p> -->
              <p class="jumpOver f_16 color_blue fr cursor_p" v-if="showJump" @click="routerBack">跳过</p>
              <p class="edit f_16 color_blue fr cursor_p" v-if="isjumpOver && !formEditState && userInfoState" @click="formEditState = true"><span class="iconfont iconedit- color_blue"></span>编辑</p>
            </div>
            <div class="desc f_14 color_60">仅限被邀请 HR 限时免费使用</div>
          </div>
          <!-- 表单 -->
          <div class="form">
            <dl class="formItem flex" :class="[errorTips.name?'errorTips':'']">
              <dt class="f_14 color_60"><span>姓名</span>：</dt>
              <dd class="flex1">
                <el-input class="restInput f_14 color_40" v-model="userInformation.name" placeholder="请输入你的姓名" :maxlength="10" @focus="inputFocus('name')"></el-input>
                <div class="errorTipsDesc f_14" v-if="errorTips.name">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.name}}</span>
                </div>
              </dd>
            </dl>
            <!-- <dl class="formItem flex" :class="[errorTips.phone?'errorTips':'']">
              <dt class="f_14 color_60"><span>手机号码</span>：</dt>
              <dd class="flex1">
                <el-input class="restInput f_14 color_40" v-model="userInformation.phone" placeholder="请输入你的手机号码" :maxlength="11" @focus="inputFocus('phone')"></el-input>
                <div class="errorTipsDesc f_14" v-if="errorTips.phone">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.phone}}</span>
                </div>
              </dd>
            </dl> -->
            <dl class="formItem flex pr" :class="[errorTips.company?'errorTips':'']">
              <dt class="f_14 color_60"><span>公司名称</span>：</dt>
              <dd class="flex1">
                <!-- <div class="company f_14 color_40 flex" v-if="userInfo.company">
                  <p class="flex1 ellipsis">{{userInformation.company}}</p>
                  <p class="color_blue cursor_p" @click="toCompany()">去编辑</p>
                </div> -->
                <!-- 智能联想 -->
                <el-autocomplete class="restInput f_14 color_40" :class="[errorTips.company?'error':'']" popper-class="searchCompany" :maxlength="20" placeholder="请输入你的公司名称" v-model="userInformation.company" :fetch-suggestions="companySearch" @blur="companyBlur" @select="handleCompany" @focus="inputFocus('company')">
                  <template slot-scope="{item}">
                    <template v-if="item.token">
                      <div class="name" v-if="item.full_name.length">
                        <template v-if="item.full_name.length===1 && searchIngCompanyList[item.index].full_name===userInformation.company">
                          <span class='es-highlighter'>{{item.full_name[0]}}</span>
                        </template>
                        <template v-else-if="searchIngCompanyList[item.index].full_name.indexOf(userInformation.company) >-1">
                          <span v-for="(sitem,sindex) in item.full_name" :key="String(sindex)"><span class='es-highlighter' v-if="sindex == item.full_name.length-1">{{userInformation.company}}</span>{{sitem}}</span>
                        </template>
                        <template v-else>
                          {{item.full_name[0]}}
                        </template>
                      </div>
                      <div class="name" v-else>
                        <span class='es-highlighter'>{{userInformation.company}}</span>
                      </div>
                    </template>
                    <div class="name nullTips" v-else>没有找到公司</div>
                  </template>
                </el-autocomplete>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.company">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.company}}</span>
                </div>
              </dd>
              <div class="tipsIcon iconfont icontishi1 pa cursor_p" @click="showWxTips=true"></div>
            </dl>
            <dl class="formItem flex" :class="[errorTips.company_position?'errorTips':'']">
              <dt class="f_14 color_60"><span>职位</span>：</dt>
              <dd class="flex1">
                <el-input class="restInput f_14 color_40" v-model="userInformation.company_position" placeholder="请输入你的职位" @focus="inputFocus('company_position')" :maxlength="20" ></el-input>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.company_position">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.company_position}}</span>
                </div>
              </dd>
            </dl>
            <dl class="formItem flex" :class="[errorTips.company_email ? 'errorTips':'']">
              <dt class="f_14 color_60"><span>公司邮箱</span>：</dt>
              <dd class="flex1">
                <div class="company f_14 color_40 flex" v-if="userInfo.company_email">
                  <p class="flex1 ellipsis">{{userInformation.company_email}}</p>
                  <p class="color_blue cursor_p" @click="confirmForm()">去编辑</p>
                </div>
                <div class="restInput button f_14 cursor_p" :class="[userInformation.company_email? 'color_40': 'placeholder']" v-else @click="confirmForm()" >{{userInformation.company_email || '请输入你的公司邮箱'}}</div>
                <!-- <div class="restInput f_14 color_40" v-else>{{userInformation.company_email || '请输入你的公司邮箱'}}</div> -->
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.company_email && !showBindEmailState">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.company_email}}</span>
                </div>
              </dd>
            </dl>
          </div>
          <div class="formButtons clearfix">
            <div class="fr confirm text_center bg_current color_fff f_14 cursor_p" @click="confirmForm(true)">确定</div>
            <div class="fr cancel text_center color_blue f_14 cursor_p" v-if="userJWT.h_t && userInfoState" @click="cancelForm();">取消</div>
          </div>
          
        </div>

      </div>

      <!-- 已经有完善信息时列表展示 -->
      <div class="formList bg_fff" :class="[isLoading?'opacity':'']" v-else>
        <div class="listBox" :class="[editModule.user?'edit':'']">
          <div class="title clearfix f_16 color_40">
            个人信息
            <div class="edit f_14 color_blue fr cursor_p" v-if="!editModule.user" @click="cancelForm('company');editModule.user = true"><span class="iconfont iconedit- color_blue"></span>编辑</div>
          </div>
          <div class="listCont pr">
            <div class="list flex-c">
              <div class="name f_14 color_60"><span>姓名</span>：</div>
              <div class="value">
                <p class="" v-if="!editModule.user">{{userInformation.name}}</p>
                <el-input class="restInput f_14 color_40" :class="[errorTips.name?'error':'']" v-model="userInformation.name" placeholder="请输入你的姓名" :maxlength="10" @focus="inputFocus('name')" v-if="editModule.user"></el-input>
              </div>
              <div class="errorTipsDesc f_14 flex1">
                <template v-if="editModule.user && errorTips.name">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.name}}</span>
                </template>
              </div>
            </div>
            <!-- <div class="list flex-c">
              <div class="name f_14 color_60"><span>手机号码</span>：</div>
              <div class="value">
                <p class="" v-if="!editModule.user">{{userInformation.phone}}</p>
                <el-input class="restInput f_14 color_40" :class="[errorTips.phone?'error':'']" v-model="userInformation.phone" placeholder="请输入你的手机号码" :maxlength="11" @focus="inputFocus('phone')" v-if="editModule.user"></el-input>
              </div>
              <div class="errorTipsDesc f_14 flex1">
                <template v-if="editModule.user && errorTips.phone">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.phone}}</span>
                </template>
              </div>
            </div> -->
            <div class="list flex-c">
              <div class="name f_14 color_60"><span>职位</span>：</div>
              <div class="value">
                <p class="" v-if="!editModule.user">{{userInformation.company_position}}</p>
                <el-input class="restInput f_14 color_40" :class="[errorTips.company_position?'error':'']" v-model="userInformation.company_position" placeholder="请输入你的职位" :maxlength="20" @focus="inputFocus('company_position')" v-if="editModule.user"></el-input>
              </div>
              <div class="errorTipsDesc f_14 flex1">
                <template v-if="editModule.user && errorTips.company_position">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.company_position}}</span>
                </template>
              </div>
            </div>
            <div class="avatar pa cursor_p" v-if="!editModule.user">
              <img :src="userInformation.wechat_avatar || headImgList.round[isNaN(userTokenNumber%5)?0:userTokenNumber%5]" alt="">
              <div class="iconfont iconpaizhao pa color_fff text_center cursor_p">
                <input type="file" class="avatar-uploader pa cursor_p" ref="fileUpload" @change="fileUpload">
              </div>
            </div>
            <div class="formButtons clearfix" v-if="editModule.user">
              <div class="fr confirm text_center bg_current color_fff f_14 cursor_p" @click="updateData('user')">确定</div>
              <div class="fr cancel text_center color_blue f_14 cursor_p" @click="cancelForm('user');">取消</div>
            </div>
          </div>
        </div>

        <div class="listBox">
          <div class="title clearfix f_16 color_40">
            联系方式
            <div class="edit f_14 color_blue fr cursor_p" v-if="!editModule.email" @click="cancelForm('user');cancelForm('company');showEditEmail()"><span class="iconfont iconedit- color_blue"></span>编辑</div>
          </div>
          <div class="listCont">
            <div class="list flex-c">
              <div class="name f_14 color_60"><span>公司邮箱</span>：</div>
              <div class="value">
                <p class="" v-if="!editModule.company_email">{{userInformation.company_email}}</p>
              </div>
              <div class="errorTipsDesc f_14 flex1">
                <template v-if="editModule.email && errorTips.email">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.email}}</span>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="listBox" :class="[editModule.company?'edit':'']">
          <div class="title clearfix f_16 color_40">
            公司信息
            <!-- <div class="edit f_14 color_blue fr cursor_p" v-if="!editModule.company" @click="toCompany('formEditState=true')"><span class="iconfont iconqiehuan color_blue"></span>更换公司</div> -->
            <div class="edit f_14 color_blue fr cursor_p" v-if="!editModule.company" @click="toCompany()"><span class="iconfont iconqiehuan color_blue"></span>更换公司</div>
          </div>
          <div class="companyCont flex-c" v-if="userCompanyData.token">
            <img class="logo" :src="userCompanyData.logo_hr || userCompanyData.logo" alt="">
            <div class="flex1">
              <div class="name f_14 color_40">{{userCompanyData.company_full_name}}</div>
              <div class="text f_12 color_9c beforeText">
                <span v-if="userCompanyData.company_type">{{userCompanyData.company_type}}</span>
                <span v-if="userCompanyData.size">{{userCompanyData.size}}</span>
                <span v-if="userCompanyData.industry_id">{{userCompanyData.industry.cn}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="listCont">
            <div class="list flex-c">
              <div class="name f_14 color_60"><span>公司名称</span>：</div>
              <div class="value">
                <p class="cursor_p" v-if="!editModule.company"  @click="toCompany('formEditState=true')">{{userInformation.company}}</p>
                <el-autocomplete class="restInput f_14 color_40" :class="[errorTips.company?'error':'']" popper-class="searchCompany" :maxlength="20" placeholder="请输入你的公司名称" v-model="userInformation.company" :fetch-suggestions="companySearch"  v-else @select="handleCompany" @focus="inputFocus('company')">
                  <template slot-scope="{item}">
                    <div class="name" v-if="item.name.length">
                      <template v-if="item.name.length===1 && searchIngCompanyList[item.index].name===userInformation.company">
                        <span class='es-highlighter'>{{item.name[0]}}</span>
                      </template>
                      <template v-else-if="searchIngCompanyList[item.index].name.indexOf(userInformation.company) >-1">
                        <span v-for="(sitem,sindex) in item.name" :key="String(sindex)"><span class='es-highlighter' v-if="sindex == item.name.length-1">{{userInformation.company}}</span>{{sitem}}</span>
                      </template>
                      <template v-else>
                        {{item.name[0]}}
                      </template>
                    </div>
                    <div class="name" v-else>
                      <span class='es-highlighter'>{{userInformation.company}}</span>
                    </div>
                  </template>
                </el-autocomplete>
              </div>
              <div class="errorTipsDesc f_14 flex1">
                <template v-if="editModule.company && errorTips.company">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.company}}</span>
                </template>
              </div>
            </div>
            <div class="formButtons clearfix" v-if="editModule.company">
              <div class="fr confirm text_center bg_current color_fff f_14 cursor_p" @click="updateData('company')">确定</div>
              <div class="fr cancel text_center color_blue f_14 cursor_p" @click="cancelForm('company');">取消</div>
            </div>
          </div> -->
        </div>
        
      </div>
      
    </div>

    <!-- 绑定邮箱弹层 -->
    <div class="bindEmailTips" v-if="showBindEmailState || editModule.email">
      <div class="tipsContent pa bg_fff">
        <div class="tipsTitle f_18 color_40 font_w_b">公司邮箱验证</div>

        <div class="form">
          <dl class="formItem flex" :class="[errorTips.email?'errorTips':'']">
            <dt class="f_14 color_60"><span>公司邮箱</span>：</dt>
            <dd class="flex1">
              <el-input class="restInput f_14 color_40" v-model="emailData.email" placeholder="请输入你的公司邮箱" @focus="inputFocus('email')" :maxlength="64" ></el-input>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.email">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.email}}</span>
              </div>
            </dd>
          </dl>
          <dl class="formItem flex" :class="[errorTips.code?'errorTips':'']">
            <dt class="f_14 color_60"><span>验证码</span>：</dt>
            <dd class="flex1">
              <div class="codeBox flex-c">
                <el-input class="restInput f_14 color_40 flex1" v-model="emailData.code" placeholder="请输入验证码" @focus="inputFocus('code')" :maxlength="6" ></el-input>
                <div class="time cursor_p text_center f_14">
                  <span class="color_blue" @click="getCode()" v-if="time === 60">发送验证码</span>
                  <span class="color_90" v-else >{{time}}s</span>
                </div>
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.code">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.code}}</span>
              </div>
            </dd>
          </dl>
          <div class="bindEmailCode"></div>
<!--          <div class="bindEmailCode f_14 color_9c"><span class="cursor_p" @click="showEmailBind">无法收到验证码？</span></div>-->
        </div>
        <div class="formButtons clearfix">
          <div class="fr confirm text_center bg_current color_fff f_14 cursor_p" @click="bindEmail()">确定</div>
          <div class="fr cancel text_center color_60 f_14 cursor_p" @click="cancelBindEmail();">取消</div>
        </div>
      </div>
    </div>
    
    <!-- 没找到所属公司提示 -->
    <div class="wechatTips text_center" v-if="showWxTips" @click="showWxTips=false">
      <div class="content pa bg_fff" @click.stop>
        <div class="title f_16 color_40">没找到所属公司？</div>
        <div class="text f_14 color_9c">微信扫码联系招聘小助手，快速添加公司信息。</div>
        <img src="https://files.wondercv.com/hr/wechatTips.png" alt="">
      </div>
    </div>

    <userBindEmail v-if="emailBindState" :email='emailData.email' :errorState="emailBindErrorState"
    @hideUserBindEmailState="hideUserBindEmailState" @confirm="bindEmailConfirm" @hideEmailBindError='hideEmailBindError' />
    <!-- 上传营业执照或者修改邮箱 -->
    <error v-if="showErrorBox" :email="emailData.email" @editEmail="showErrorBox = false" :top="'310px'" />
  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'

import { mapState, mapMutations } from 'vuex'
import { getValLenngth, isToggleUser, get_tUser, updateJWT } from '@/utils/utils'
import company_options from '@/utils/company_options'
import { headImgList } from '@/utils/static'
import userBindEmail from '@/components/block/UserBindEmail'
import error from '@/components/companyAudit/error'

export default {
  name: 'talentUserinfo',
  data(){
    return {
      isLoading:true,
      showJump:false, //是否展示从登录注册来的新用户跳过按钮
      is_new_user:false, //是否是新用户
      isjumpOver:true, // 是否已经跳过
      formEditState:true,// 是否可编辑
      userInfo:{},//备份的用户数据
      userInformation:{ //表单数据集合
        name: '',
        // phone: '',
        company: '',//页面显示的公司名
        company_id: '', //选择的公司id
        company_name: '', //选择的公司名
        cust_company_name: '', //自己填的公司名
        company_position:'', //职位
        company_email: '',
      },
      errorTips:{ //表单错误提示集合
        name:'',
        // phone:'',
        company:'',
        company_position:'',
        company_email:'',
        email: '',
        code:'',
      },
      editModule:{ //单独编辑合集
        user:false,//用户信息
        company:false,//公司编辑
        email:false, //邮箱
      },
      company:'',
      companyList:[],//搜索出来的公司列表
      searchIngCompanyList:[],//备份
      
      emailData:{//邮箱数据
        email: '',
        code:'',
      },
      showBindEmailState:false, //显示绑定邮箱
      getCodeState:false, //获取验证码的状态
      time:60,
      timeName:'',
      cannotEmail:['@qq.com','@163.com','@126.com','@gmail','outlook.com','@hotmail.com','.edu','@sohu.com','@sina.com'],//不能输入的邮箱
      userJWT:{},
      backToIndex:false,//是否返回主页
      link_to:'',
      showWxTips:false, //提示微信二维码

      emailBindState:false,//手动绑定弹层显示状态
      emailBindEdit:'',//是否是修改邮箱
      emailBindErrorState:false,//错误状态提示

      userCompanyData:{},//用户公司信息
      userTokenNumber:0,
      headImgList: headImgList,
      showErrorBox: false, // 更换邮箱是否正确
    }
  },
  computed:{
    ...mapState('block', ['userInfoState', 'userinfoTipsState'])
  },
  components:{
    userBindEmail,
    error
  },
  async created(){
    let { backToIndex, link_to, showJump } = this.$route.query;
    this.backToIndex = backToIndex || false;
    this.link_to = link_to || '';
    this.userJWT = get_tUser();
    this.showJump = showJump==='true' ? true : false;

    this.userTokenNumber = this.userJWT.t.charAt(this.userJWT.t.length-1) || 0;
    // 已经是hr了
    if(this.userJWT.h_t){
      this.getUserinfo();
      // 获取默认头像
    }else{
      window.location.href = `${window.location.origin}/talent/binduser?link_to=${encodeURIComponent(encodeURIComponent(window.location.href))}`
      // this.isLoading = false;
      // 修改信息完整状态
      this.toggleUserInfoState(false);
      // 需要hr权限

      //获取c端绑定信息
      // this.getUserBindInfo();
    }
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState','toggleUserinfoTips','updateUserBindEmailState']),
    // 获取用户信息
    async getUserinfo(){
      let userInfo = await actions.hr_accounts.getUserinfo();
      this.toggleUserInfoState(userInfo.id ? userInfo : false);
      let { company_name, cust_company_name, name} = userInfo;
      // phone
      userInfo.company = company_name || cust_company_name || '';
      this.userInfo = {...userInfo};
      this.userInformation = {...userInfo};
      // 用户信息保存完整，首次进入进入不可编辑状态
      if(this.userInfoState){
        this.formEditState = false;
        this.isLoading = false;
      }else{
        // 需要hr权限
        window.location.href = `${window.location.origin}/talent/binduser?link_to=${encodeURIComponent(encodeURIComponent(window.location.href))}`;
        // this.isLoading = false;
        return
      }
      //获取公司信息
      if(userInfo.company_token){
        this.getUserCompanyData(userInfo.company_token, (data) => {
          // 获取到公司详情后，判断一下公司有没有绑定品牌，如果绑定了品牌，则获取品牌的详情并且展示
          if (data.brand_token) {
            this.getUserCompanyData(data.brand_token)
          }
        })
      }
      // 填写过数据，即视为完成填写
      // if(company_name!='' || phone.length!='' || name.length!=''){
      //   this.isjumpOver = true;
      // }
    },
    //保存表单
    async confirmForm(checkEmail){
      let { name, company, company_position, company_email } = this.userInformation;
      let formState = true;
      if(!name){
        this.errorTips.name = '请输入真实姓名';
        formState = false;
      }
      if(getValLenngth(name)>20){
        this.errorTips.name = '请输入正确的真实姓名';
        formState = false;
      }
      // if(!phone){
      //   this.errorTips.phone = '请输入手机号';
      //   formState = false;
      // }
      // if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
      //   this.errorTips.phone = '请输入正确的手机号';
      //   formState = false;
      // }

      // if(phone.length === 11){
      //   let checkPhoneRes =  await actions.hr_accounts.hr_verification_phones({phone})
      //   if(checkPhoneRes.code !== 1000){
      //     this.errorTips.phone = checkPhoneRes.message;
      //     formState = false;
      //   }
      // }
      if(!company){
        this.errorTips.company = '请输入公司全称';
        formState = false;
      }else{
      //判断填写的公司名称是否是库里包含的
        let companyItem = {}
        this.searchIngCompanyList.forEach(item=>{
          if(item.full_name === company || !item.full_name.length){
            companyItem = item;
          }
        })
        if(!companyItem.full_name){
          this.userInformation.company = '';
          this.errorTips.company = '请输入正确的公司全称';
          formState = false;
        }
      }

      if(!company_position){
        this.errorTips.company_position = '请输入职位名称';
        formState = false;
      }
      if(!company_email && checkEmail){
        this.errorTips.company_email = '请填写公司邮箱';
        formState = false;
      }
      if(!formState){
        return false;
      }
      //只有点页面保存才会执行这个方法
      if(checkEmail){
        this.submitForm();
        return false;
      }
      //完善信息才能保存邮箱
      this.emailData = {
        email:this.userInformation.company_email,
        code:''
      };
      this.showBindEmailState = true;
      // this.submitForm();
    },
    //提交表单
    submitForm(){
      //判断填写的公司名称是否是库里包含的
      let company = {}
      this.searchIngCompanyList.forEach(item=>{
        // console.log(item.name , this.userInformation.company)
        // console.log(item.name === this.userInformation.company)
        if(item.full_name === this.userInformation.company || !item.full_name.length){
          company = item;
        }
      })
      if(company.full_name){
        this.userInformation.company_token = company.token; //选择的公司id
        this.userInformation.company_name = ''; //自己填的公司名/
      }else{
        this.userInformation.company = '';
        this.userInformation.company_token = ''; //选择的公司id
        this.userInformation.company_name = ''; //自己填的公司名
        this.$message({
          message: '请输入正确的公司全称',
          type: 'success'
        });
        return false;
      }
      //判断是否更换用户
      let toggleUserData = isToggleUser();
      if(toggleUserData.state){
        //刷新页面
        location.reload();
        return false;
      }

      // console.log(this.userJWT)
      if(!this.userJWT.h_t){
        //不是hr，保存时走创建用户信息
        this.creatUser(this.userInformation);
      }else{
        //是hr，走更新方法
        this.updateUser(this.userInformation);
      }
      
    },
    //【公司】搜索公司名称
    companySearch(queryString, cb) {
      queryString = queryString.trim();
      this.company = queryString;
      this.userInformation.company = queryString;
      cb([]);
      if(!queryString){
        return false;
      }
      let query = {
        from:0,
        size:30,
        keyword:queryString
      }
      actions.company.get_company_name(query).then(res=>{
        if(res.code === 1000){
          let { companies } = res.data;
          this.searchIngCompanyList = JSON.parse(JSON.stringify(companies));
          //防止同指针，污染 searchIngCompanyList
          let companyList = [...companies];
          //拆分数据
          companyList.forEach((item,index)=>{
            let name = [item.full_name];
            if(item.full_name.indexOf(queryString)>-1){
              name = item.full_name.split(queryString).filter(sitem => sitem)
            }
            item.index = index;
            item.full_name = name
          })
          // 调用 callback 返回建议列表的数据
          cb(companyList.length ? companyList : [{token:''}]);
        }
      })
      
    },
    //【城市】点击城市筛选项
    handleCompany(item) {
      if(!item.token){
        this.userInformation.company = '';
        return false
      }
      this.userInformation.company = this.searchIngCompanyList[item.index].full_name;
    },
    //【公司】失焦，如果匹配不上，直接情况输入框
    companyBlur(){
      setTimeout(() => {
        let company = this.userInformation.company ? this.userInformation.company.trim() : '';
        let hasCompany = false;
        if(!company){
          this.userInformation.company = ''
          return false;
        }
        this.searchIngCompanyList.forEach(item=>{
          if(item.full_name === company){
            hasCompany = true;
          }
        })
        if(!hasCompany){
          this.userInformation.company = '';
        }
      }, 200);
    },
    //取消错误提示
    inputFocus(type){
      this.errorTips[type] = ''
      if(type === 'email'){
        this.errorTips.company_email = ''
      }
    },
    //取消编辑
    cancelForm(type){
      this.editModule[type] = false;
      let { name, company, company_position, company_email } = this.userInfo;
      //改变状态，还原备份数据
      if(type === 'user'){
        this.userInformation.name = name;
        // this.userInformation.phone = phone;
        this.userInformation.company_position = company_position;
        this.errorTips.name = '';
        // this.errorTips.phone = '';
        this.errorTips.company_position = '';
      }else if(type === 'company'){
        this.userInformation.company = company;
        this.errorTips.company = '';
      }
    },
    //更新用户信息
    updateUser(data){
      let { email, code} = this.emailData;
      let submitData = JSON.parse(JSON.stringify(data));
      if(email){
        submitData.company_email = email;
        submitData.email_code = code;
      }
      //没有保存邮箱，直接删除参数
      if(!this.showBindEmailState){
        delete(submitData.company_email)
      }
      actions.hr_accounts.updateUserinfo(submitData).then(async res=>{
        if(res.code === 1000){
          //跳过之后，执行刷新jwt功能
          let jwt = await actions.jwt.refreshJwt({});
          updateJWT({jwt});
          this.userJWT = get_tUser();
          //更改数据
          this.userInformation.company_email = email;
          this.$message({
            message: '用户信息绑定成功',
            type: 'success'
          });
          //有返回首页参数
          if(this.backToIndex){
            setTimeout(() => {
              this.$router.push({name:'talentSearchIndex'})
            }, 1000);
            return false;
          }
          if(this.link_to){
            setTimeout(() => {
              window.location.href = decodeURIComponent(decodeURIComponent(this.link_to));
            }, 1000);
            return false;
          }
          this.userInfo = {...this.userInformation};
          this.formEditState = false;// 是否可编辑
          this.showBindEmailState = false; //收起邮箱弹层

          this.userJWT = get_tUser();
          // 已经是hr了,重新获取页面数据
          if( this.userJWT.h_t){
            this.getUserinfo();
          }

        }else{
          if(res.message==='系统未收到邮件，请重新发送邮件确认'){
            this.emailBindErrorState = true;
            return false;
          }
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //自动创建空用户 或者 创建用户
    creatUser(data){
      let { email, code} = this.emailData;
      let submitData = JSON.parse(JSON.stringify(data));
      if(email){
        submitData.company_email = email;
        submitData.email_code = code;
      }
      
      actions.hr_accounts.create_userinfo(submitData).then(async res=>{
        //正在loading
        this.updateUserBindEmailState(false)
        if(res.code === 1000){
          //跳过之后，执行刷新jwt功能
          let { jwt, jwt_timestamp } = res.data;
          await updateJWT({
            jwt,
            jwt_timestamp: jwt_timestamp
          });
          this.userJWT = get_tUser();
          //更改数据
          this.userInformation.company_email = email;

          this.isLoading = false;
          //正常创建，非默认创建
          this.$message({
            message: '用户信息绑定成功',
            type: 'success'
          });
          //有返回首页参数
          if(this.backToIndex){
            setTimeout(() => {
              this.$router.push({name:'talentSearchIndex'})
            }, 1000);
            return false;
          }
          if(this.link_to){
            setTimeout(() => {
              window.location.href = decodeURIComponent(decodeURIComponent(this.link_to));
            }, 1000);
            return false;
          }
          this.userInfo = {...this.userInformation};
          this.getUserinfo(); //重新获取信息
          this.formEditState = false;// 是否可编辑
          this.showBindEmailState = false; //收起邮箱弹层
          //关闭绑定邮箱弹层
          this.cancelBindEmail();
        }else{
          this.isLoading = false;
          if(res.message==='系统未收到邮件，请重新发送邮件确认'){
            this.emailBindErrorState = true;
            return false;
          }
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })    
    },
    //【单独】更新用户信息验证方法
    updateData(type){
      let { name, company, company_position, company_email, email_code } = this.userInformation;
      let formState = true;
      //判断是否更换用户
      let toggleUserData = isToggleUser();
      if(toggleUserData.state){
        //刷新页面
        location.reload();
        return false;
      }

      if(type === 'user'){
        if(!name){
          this.errorTips.name = '请输入真实姓名';
          formState = false;
        }
        if(getValLenngth(name)>20){
          this.errorTips.name = '请输入正确的真实姓名';
          formState = false;
        }
        // if(!phone){
        //   this.errorTips.phone = '请输入手机号';
        //   formState = false;
        // }
        // if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
        //   this.errorTips.phone = '请输入正确的手机号';
        //   formState = false;
        // }
        if(!company_position){
          this.errorTips.company_position = '请输入职位名称';
          formState = false;
        }
        if(!formState){
          return false;
        }
        let data = {
          name,
          // phone,
          company_position
        }
        this.updateDataSubmit(data,()=>{
          this.editModule[type] = false;
          this.userInfo.name = name;
          // this.userInfo.phone = phone;
          this.userInfo.company_position = company_position;
        });
      }else if(type === 'company'){
        if(!company){
          this.errorTips.company = '请输入公司全称';
          formState = false;
        }
        let companyAry = ["某", "知名", "国内"];
        const companyIndex = companyAry.findIndex(
          val => company.indexOf(val) !== -1
        );
        if (companyIndex !== -1) {
          this.errorTips.company = '请输入正确的公司全称';
          formState = false;
        }
        if(!formState){
          return false;
        }
        //判断填写的公司名称是否是库里包含的
        let data = {
          company_id:'',
          company_name:'',
        }
        let companyData = {}
        this.searchIngCompanyList.forEach(item=>{
          if(item.full_name === company || !item.full_name.length){
            companyData = item;
          }
        })
        if(companyData.full_name){
          data.company_token = companyData.token; //选择的公司id
          data.company_name = ''; //自己填的公司名/
        }
        // else{
        //   data.company_id = ''; //选择的公司id
        //   data.company_name = company; //自己填的公司名
        // }
        this.updateDataSubmit(data,()=>{
          this.editModule[type] = false;
          
          if(companyData.name){
            this.userInfo.company_id = companyData.id; //选择的公司id
            this.userInfo.company_name = ''; //自己填的公司名/
          }else{
            this.userInfo.company_id = ''; //选择的公司id
            this.userInfo.company_name = company; //自己填的公司名
          }
        });
      }else if(type === 'email'){
        //判断填写的公司名称是否是库里包含的
        let { email, code } = this.emailData;
        let data = {
          company_email: email,
          email_code: code,
        }
        this.company_emails(data,()=>{
          this.editModule[type] = false;
          this.userInformation.company_email = email;
          this.userInformation.email_code = code;
        });
      }
    },
    //【单独】更新用户信息验证保存
    updateDataSubmit(data,callback){
      actions.hr_accounts.updateUserinfo(data).then(async res=>{
        //正在loading
        this.updateUserBindEmailState(false)
        if(res.code === 1000){
          this.$message({
            message: '用户信息绑定成功',
            type: 'success'
          });
          //关闭绑定邮箱弹层
          this.cancelBindEmail();
          callback && callback()
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },

    //【邮箱】获取验证码
    getCode(){
      //防抖
      if(this.getCodeState){
        return false;
      }
      //对电子邮件的验证
      var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
      // let hasCannotEmail = false;
      // this.cannotEmail.forEach(item=>{
      //   if(this.emailData.email.indexOf(item)>-1){
      //     hasCannotEmail = true;
      //   }
      // })
      if(!myreg.test(this.emailData.email)){
        this.errorTips.email = '请填写有效的公司邮箱';
        return false;
      }
      this.getCodeState = true;
      let data={
        receiver: this.emailData.email,
        type: 'email',
        source: 'audit'
      }
      //发送验证码
      actions.hr_accounts.verification_codes(data).then(res=>{
        if(res.code === 1000){
          this.$message({
            message: '邮箱验证码已发送',
            type: 'success'
          });
          this.time = 59;
          this.codeTime();
        }else{
          this.getCodeState = false;
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //【邮箱】保存
    bindEmail(){
      //对电子邮件的验证
      var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
      // console.log(this.emailData.email)
      // let hasCannotEmail = false;
      // this.cannotEmail.forEach(item=>{
      //   if(this.emailData.email.indexOf(item)>-1){
      //     hasCannotEmail = true;
      //   }
      // })
      if(!myreg.test(this.emailData.email)){
        this.errorTips.email = '请填写有效的公司邮箱';
        return false;
      }
      if(!this.emailData.code || this.emailData.code.length !=6){
        this.errorTips.code = '请输入正确的验证码';
        return false;
      }
      // this.userInformation.company_email = this.emailData.email;
      // this.userInformation.email_code = this.emailData.code;
      if(this.editModule.email){
        //走另一种方式
        this.updateData('email')
      }else{
        //完善信息页面，之后，才能保存邮箱，然后直接保存
        this.submitForm();
      }
    },
    //单独保存公司
    company_emails(data,callback){
      let hasCannotEmail = false;
      this.cannotEmail.forEach(item=>{
        if(data.company_email.indexOf(item)>-1){
          hasCannotEmail = true;
        }
      })
      if(hasCannotEmail) {
        this.showErrorBox = true
        return
      }
      actions.hr_accounts.company_emails(data).then(async res=>{
        if(res.code === 1000){
          this.$message({
            message: '用户信息绑定成功',
            type: 'success'
          });
          callback && callback()
        }else{
          if(res.message==='系统未收到邮件，请重新发送邮件确认'){
            callback && callback(true);
            return false;
          }
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //【邮箱】倒计时
    codeTime(){
      this.timeName = setInterval(() => {
        if(this.time == 1){
          clearInterval(this.timeName);
          this.time = 60;
          this.getCodeState = false;
          return false;
        }
        this.time = this.time-1;

      }, 1000);
    },
    //【邮箱】弹出邮箱弹层
    showEditEmail(){
      //完善信息才能保存邮箱
      this.emailData = {
        email:this.userInformation.company_email,
        code:''
      };
      this.editModule.email = true;
    },
    //【邮箱】关闭
    cancelBindEmail(){
      this.showBindEmailState = false;
      this.editModule.email = false;
      this.getCodeState = false; //获取验证码的状态
      this.time=60;
      clearInterval(this.timeName);
    },
    //获取c端绑定信息
    // async getUserBindInfo(){
    //   let res = await actions.account.get_users_bind_info();
    //   if(res.status===1){
    //     this.userInformation.phone = res.data.user.phone || '';
    //   }
    // },

    // 获取公司信息
    getUserCompanyData(token, callback){
      actions.company.get_company_companies(token,{type:'hr'}).then(res=>{
        if(res.code === 1000){
          let { size_max } = res.data;
          //公司规模
          res.data.size = ''
          if(size_max){
            company_options.scale_options.forEach(item=>{
              if(size_max<=item.max && !res.data.size){
                res.data.size = item.label
              }
            })
          }
          this.userCompanyData = res.data;
          callback && callback(res.data)
        }
      })
    },
    //去公司信息页面
    // toCompany(val){
    //   window.open(`/talent/company?${val}`,'_blank');
    // },
    toCompany () {
      this.$router.push({
        name: 'talentCompany',
        params: { showReplaceDialog: true }
      })
    },
    //【反向绑定】切换显示状态
    hideUserBindEmailState(){
      this.emailBindState = false;
    },
    //【反向绑定】显示手动绑定邮箱弹层
    showEmailBind(){
      //对电子邮件的验证
      var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
      let hasCannotEmail = false;
      this.cannotEmail.forEach(item=>{
        if(this.emailData.email.indexOf(item)>-1){
          hasCannotEmail = true;
        }
      })
      if(hasCannotEmail || !myreg.test(this.emailData.email)){
        this.errorTips.email = '请填写有效的公司邮箱';
        return false;
      }
      //检测邮箱是否重复
      actions.hr_accounts.verification_emails({company_email:this.emailData.email}).then(res=>{
        if(res.code === 1000){
          //显示手动弹窗弹层
          this.emailBindState = true;
          //同步是否正在编辑邮箱
          this.emailBindEdit = this.editModule.email;
          //关闭绑定邮箱弹层
          this.cancelBindEmail();
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //【反向绑定】绑定邮箱
    bindEmailConfirm(code){
      //正在loading
      this.updateUserBindEmailState(true)

      if(this.emailBindEdit){
        //走另一种方式
        // this.updateData('email')
        //判断填写的公司名称是否是库里包含的
        let { email } = this.emailData;
        let data = {
          company_email: email,
          email_code: code,
        }
        this.company_emails(data,(type)=>{
          //正在loading
          this.updateUserBindEmailState(false)
          if(type){
            this.emailBindErrorState = true;
            return false;
          }
          this.editModule[email] = false;
          this.userInformation.company_email = email;
          this.userInformation.email_code = code;
          this.getUserinfo();
          //关闭绑定邮箱弹层
          this.hideUserBindEmailState();
        });
      }else{
        this.emailData.code = code
        //完善信息页面，之后，才能保存邮箱，然后直接保存
        this.submitForm();
      }
    },
    //【反向绑定】取消错误提示
    hideEmailBindError(){
      this.emailBindErrorState = false;
    },
    //跳过
    routerBack(){
      //有返回首页参数，并且只能去搜索列表
      if(this.link_to && ( this.link_to.includes('/talent/search/list') || this.link_to.includes('/talent/resume/detail') ) ){
        window.location.href = decodeURIComponent(decodeURIComponent(this.link_to));
      }else{
        this.$router.push({name:'talentSearchIndex'})
      }
    },

    //【上传头像】上传之前验证
    beforeFileUpload(file) {
      const fileTypes = 'image/png,image/gif,image/jpeg,image/tif,image/tiff,image/bmp,image/x-bmp'
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!fileTypes.includes(file.type)) {
        this.$message.error('上传头像格式错误!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    //【上传头像】图片上传
    fileUpload(e){
      // 获取图片base64
      let file = this.$refs.fileUpload.files[0]
      if(!this.beforeFileUpload(file)){
        this.$refs.fileUpload.value = '';
        return false;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e =>{
        this.uploadAvatar(e.currentTarget.result)
      }
    },
    //【上传头像】图片上传
    uploadAvatar(avatar){
      actions.hr_accounts.uploadAvatar({avatar}).then(res=>{
        this.$refs.fileUpload.value = '';
        if(res.code===1000){
          this.$message({
            message: '头像保存成功',
            type: 'success'
          });
          //刷新数据
          this.getUserinfo();
        }else{
          this.$message.error(res.message);
        }
      })
    },


  }
}
</script>

<style lang="scss" scoped>

@import './Index.scss';

</style>